import React from 'react';

const BundleProductLoaderContext = React.createContext();

export default BundleProductLoaderContext;
